import './App.css';
import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AboutUsPage from './components/AboutUsPage';
import ContactUsPage from './components/ConactUsPage';
import FAQsPage from './components/FAQsPage';
import FeaturesPage from './components/FeaturesPage';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import WhyWePage from './components/WhyWePage/Index';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';
import TermsConditionsPage from './components/TermsConditionsPage';
import Aos from 'aos';
import 'aos/dist/aos.css';

function App() {
    Aos.init();

        useEffect(() => {
            Aos.init({ duration: 3000 });
        }, []);
    
// contact us issue solve
    return (
        <>
            <ToastContainer />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={
                        <>
                            <HomePage />
                            <AboutUsPage />
                            <FeaturesPage />
                            <WhyWePage />
                            <FAQsPage />
                            <ContactUsPage />
                            <Footer />
                        </>
                    } />
                    <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                    <Route path="/terms-conditions" element={<TermsConditionsPage />} />
                </Routes>
            </BrowserRouter>
        </>
    );
}

export default App;